module.exports = __webpack_public_path__ + "static/media/fairtrade.6e1fe544.jpg";